import { IAction } from '~/src/store';

import { EChangePaymentDateActions } from './index';

export type TSetChangeDate = IAction<EChangePaymentDateActions.SET_CHANGE_DATE, string>

const setChangeDate = (date: string): TSetChangeDate => ({
    type: EChangePaymentDateActions.SET_CHANGE_DATE,
    payload: date,
});

export default setChangeDate;
